import { ACTIVE_CATALOG } from "./market.js";
import type { Experience } from "./types.js";

export interface HeroRef {
  id: string;
  label: string;
}
export interface HeroCard extends Experience {
  label: string;
}

export const HEROES: HeroRef[] = [
  { id: "the-bund", label: "Shanghai" },
  { id: "forbidden-city", label: "Beijing" },
  { id: "lianhuashan", label: "Shenzhen" },
  { id: "greatwall-mutianyu", label: "Beijing" },
];
export const HERO_CARDS: HeroCard[] = HEROES.map((h) => ({
  ...ACTIVE_CATALOG.find((c) => c.id === h.id)!,
  label: h.label,
})).filter((h) => h.id);
